export default function ValueProposition() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-4">
            Why Thousands Of Users Search For
            <br />
            <span className="text-primary-500 italic">Superbuy Spreadsheet</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Superbuy spreadsheets have become essential tools for organized shopping. Here is why the
            community relies on these curated collections every day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/50 hover:border-accent-200/50 transition-all duration-300">
            <div className="relative h-56 md:h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20neatly%20arranged%20product%20cards%20and%20a%20minimal%20notebook%2C%20warm%20morning%20sunlight%20across%20a%20light%20oak%20surface%2C%20a%20small%20potted%20succulent%20adding%20life%2C%20calm%20productive%20workspace%20aesthetic%2C%20soft%20cream%20and%20sage%20tones&width=600&height=500&seq=value-save-v2-2607&orientation=landscape"
                alt="Save Time with Superbuy Spreadsheet"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/40 to-transparent h-20"></div>
            </div>
            <div className="p-5 md:p-6">
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                <i className="ri-time-line text-accent-600 text-lg"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                Save Time
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Find organized product collections instead of searching thousands of pages. Our
                Superbuy spreadsheet database puts everything at your fingertips.
              </p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/50 hover:border-accent-200/50 transition-all duration-300">
            <div className="relative h-56 md:h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Lifestyle%20flatlay%20with%20smartphone%20displaying%20product%20grid%20and%20fabric%20swatches%20scattered%20on%20linen%20textile%2C%20warm%20natural%20daylight%2C%20thoughtful%20shopping%20concept%2C%20soft%20earthy%20colors%20with%20tactile%20textures%2C%20editorial%20minimal%20style&width=600&height=500&seq=value-compare-v2-2607&orientation=landscape"
                alt="Compare Products with Superbuy Spreadsheet"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/40 to-transparent h-20"></div>
            </div>
            <div className="p-5 md:p-6">
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                <i className="ri-scales-3-line text-accent-600 text-lg"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                Compare Products Easily
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Use structured spreadsheets to compare prices, categories and information across
                hundreds of products in one organized view.
              </p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/50 hover:border-accent-200/50 transition-all duration-300">
            <div className="relative h-56 md:h-64 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20an%20open%20tablet%20on%20a%20soft%20throw%20blanket%2C%20steaming%20ceramic%20mug%20nearby%2C%20warm%20afternoon%20light%20filtering%20through%20sheer%20curtains%2C%20peaceful%20lifestyle%20scene%2C%20cream%20and%20warm%20beige%20interior%20with%20dried%20pampas%20grass&width=600&height=500&seq=value-smart-v2-2607&orientation=landscape"
                alt="Shop Smarter with Superbuy Spreadsheet"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/40 to-transparent h-20"></div>
            </div>
            <div className="p-5 md:p-6">
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-accent-600 text-lg"></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                Shop Smarter
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Learn how Superbuy works before making purchasing decisions. Access QC photos,
                guides, and verified information for confident shopping.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}